// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"401":"dbe67189","453":"7e3bf501"}[chunkId] + ".chunk.js";
};